import {
  executeCanonicalClientOperation,
  ProductRevivalApiClient,
  type CanonicalClientTransport,
  type ClientOperation,
  type RevivalRequest,
  type RevivalTransport,
} from "@medicorepay/shared";
import apiClient from "@/lib/api-client";

const axiosTransport: RevivalTransport = async <T>(
  request: RevivalRequest,
): Promise<T> => {
  const response = await apiClient.request<T>({
    url: request.path,
    method: request.method,
    headers: request.headers,
    params: request.query,
    data: request.body,
    responseType: request.responseType,
    timeout: request.timeoutMs,
  });
  return response.data;
};

export const productRevivalApi = new ProductRevivalApiClient(
  "",
  axiosTransport,
);

export function executeWebCanonicalOperation<T>(input: {
  operation: ClientOperation;
  payload?: Readonly<Record<string, unknown>>;
  idempotencyKey: string;
  requestHash: string;
  correlationId: string;
  clientVersion: string;
  deviceId?: string;
}) {
  return executeCanonicalClientOperation<T>(
    {
      request: async <R>(
        request: Parameters<CanonicalClientTransport["request"]>[0],
      ): Promise<R> =>
        (
          await apiClient.request<R>({
            url: request.path,
            method: request.method,
            data: request.body,
            headers: request.headers,
          })
        ).data,
    },
    { channel: "WEB", mode: "ONLINE", ...input },
  );
}
